import { HttpHeaders } from '@angular/common/http';
export const API_URL =  'https://feeimageupload.capstonelogistics.com/';
// 'http://172.31.2.191:8010'; // 'http://localhost/ImageFTPHandlerAPI'; //
export const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
    })
};
